"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_OPTIONS = void 0;
exports.COOKIE_OPTIONS = {
    name: 'sb',
    lifetime: 7 * 24 * 60 * 60,
    domain: '',
    path: '/',
    sameSite: 'lax'
};
//# sourceMappingURL=constants.js.map